import i18n from "i18next";
import { initReactI18next } from "react-i18next";

//中文
import hk_global from "./locales/hk/global.json";
import hk_header from "./locales/hk/header.json";
import hk_footer from "./locales/hk/footer.json";
import hk_home from "./locales/hk/home.json";
import hk_form from "./locales/hk/form.json";
import hk_inquiry from "./locales/hk/inquiry.json";
import hk_login from "./locales/hk/login.json";
import hk_member from "./locales/hk/member.json";
import hk_s_dollar from "./locales/hk/s_dollar.json";
import hk_redeem from "./locales/hk/redeem.json";
import hk_generic from "./locales/hk/generic.json";
import hk_status_message from "./locales/hk/status_message.json";
import hk_popup from "./locales/hk/popup.json";
import hk_tnc from "./locales/hk/tnc.json";
import hk_faq from "./locales/hk/faq.json";

//EN
import hk_en_global from "./locales/hk_en/global.json";
import hk_en_header from "./locales/hk_en/header.json";
import hk_en_footer from "./locales/hk_en/footer.json";
import hk_en_home from "./locales/hk_en/home.json";
import hk_en_form from "./locales/hk_en/form.json";
import hk_en_inquiry from "./locales/hk_en/inquiry.json";
import hk_en_login from "./locales/hk_en/login.json";
import hk_en_member from "./locales/hk_en/member.json";
import hk_en_s_dollar from "./locales/hk_en/s_dollar.json";
import hk_en_redeem from "./locales/hk_en/redeem.json";
import hk_en_generic from "./locales/hk_en/generic.json";
import hk_en_status_message from "./locales/hk_en/status_message.json";
import hk_en_popup from "./locales/hk_en/popup.json";
import hk_en_tnc from "./locales/hk_en/tnc.json";
import hk_en_faq from "./locales/hk_en/faq.json";

const resources = {
  hk: {
    global: hk_global,
    header: hk_header,
    footer: hk_footer,
    home: hk_home,
    form: hk_form,
    inquiry: hk_inquiry,
    login: hk_login,
    member: hk_member,
    s_dollar: hk_s_dollar,
    redeem: hk_redeem,
    generic: hk_generic,
    status_message: hk_status_message,
    popup: hk_popup,
    tnc: hk_tnc,
    faq: hk_faq,
  },
  hk_en: {
    global: hk_en_global,
    header: hk_en_header,
    footer: hk_en_footer,
    home: hk_en_home,
    form: hk_en_form,
    inquiry: hk_en_inquiry,
    login: hk_en_login,
    member: hk_en_member,
    s_dollar: hk_en_s_dollar,
    redeem: hk_en_redeem,
    generic: hk_en_generic,
    status_message: hk_en_status_message,
    popup: hk_en_popup,
    tnc: hk_en_tnc,
    faq: hk_en_faq,
  },
};

i18n.use(initReactI18next).init({
  resources,
  ns: [
    "global",
    "header",
    "footer",
    "home",
    "form",
    "inquiry",
    "login",
    "member",
    "s_dollar",
    "redeem",
    "generic",
    "error_message",
    "popup",
    "tnc",
    "faq"
  ],
  fallbackLng: "hk",
  lng: "hk",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
